import gql from 'graphql-tag';

export const mutationDeleteDokkioUser = gql`
  mutation deleteDokkioUser (
    $id: DokkioID!
  ) {
    deleteDokkioUser (
      id: $id
    )
  }
`;
export default mutationDeleteDokkioUser;
